module.exports = __webpack_public_path__ + "static/media/cup-sub.6d17a4db.svg";